import React, { useEffect, useState } from 'react';
import './OTSHistory.scss';
import { getOtsHistory } from "../../services/otsEventService";
import { useAuthentication } from "meportal/AuthenticationProvider";
import { OtsAircraft } from "../../Models/OtsAircraft";
import { useDispatch } from 'react-redux'; 
import { editAircraft } from "../../store/feature/OtsAircraftSlice";

interface OTSHistory {
    Id: string;
    EventType: string;
    EventTypeCategory: string;
    Airline: string;
    AircraftRegistration: string;
    AtaCode: string;
    IsEtopsCapable: boolean;
    Station: string;
    Location: string;
    ProblemText: string;
    Advise: string;
    ETR: string;
    AdviseTimeBump: number;
    EstimatedReturnTimeBump: number;
    ReturnToService: string;
    ConversationUniqueKey: string;
    OutOfServiceTime: string;
}

type OTSHistoryProps = {
    aircraftNumber: string;
    ataCode: string;
    reload?: any;
    isTailValid: boolean;
};

export default function OTSHistory(props: OTSHistoryProps) {
    const { userData, getLatestAccessToken } = useAuthentication(); 
    const [otsHistoryList, setOtsHistoryList] = useState<OTSHistory[]>([]);
    const [filteredOtsHistoryList, setFilteredOtsHistoryList] = useState<OTSHistory[]>([]);
    const dispatch = useDispatch();
    const reload = props.reload;
    const isTailValid = props.isTailValid;


    useEffect(() => {
        const fetchOtsHistory = async () => {
            if (userData.profile.company && props.aircraftNumber.length === 5 && isTailValid) {
                try {
                    const aircraftRegistration = "N" + props.aircraftNumber;
                    getLatestAccessToken().then(async (token) => {
                        userData.access_token = token;
                        const otsHistory: OTSHistory[] = await getOtsHistory(userData, aircraftRegistration);
                        setOtsHistoryList(otsHistory);
                    });
                } catch (error) {
                    console.error('Failed to fetch OTS history:', error);
                    setOtsHistoryList([]);
                }
           
            } else {
                setOtsHistoryList([]);
            }
        };
        fetchOtsHistory();
    }, [userData, props.aircraftNumber]);

    useEffect(() => {
        const filterOtsHistoryList = () => {
            let filteredList = otsHistoryList;
            if (props.ataCode) {
                filteredList = otsHistoryList.filter(otsHistory => otsHistory.AtaCode && otsHistory.AtaCode.startsWith(props.ataCode));
            }
            setFilteredOtsHistoryList(filteredList);
        }

        filterOtsHistoryList();
    }, [props.ataCode, otsHistoryList]);

    const getReturnTime = (returnToServiceUTC: string) : number => {
        const returnDate = new Date(returnToServiceUTC);
        const currentDate = new Date();
      
        const differenceInDays = Math.ceil((currentDate.getTime() - returnDate.getTime()) / (1000 * 60 * 60 * 24));
      
        return differenceInDays;
    }

      const mapAndDispatchAircraft =(otsHistory: OTSHistory)=> {
        const otsAircraft: OtsAircraft = {
            ADVBump: otsHistory.AdviseTimeBump,
            ATACode: parseInt(otsHistory.AtaCode, 10),
            AtaCodeDescription: "",
            AdviseTimeChanges: [],
            AdviseTimeUTC: otsHistory.Advise,
            AircraftRegistration: otsHistory.AircraftRegistration.substring(1),
            Airline: otsHistory.Airline,
            AssignedTo: "",
            Audit: null,
            CreatedBy: userData.profile.name,
            DataClassification: null,
            ETRBump: otsHistory.EstimatedReturnTimeBump,
            EstimatedReturnToServiceTimeChanges: [],
            EstimatedReturnToServiceTimeUTC: otsHistory.ETR,
            IsEtopsCapable: otsHistory.IsEtopsCapable.toString(),
            LastFlightDate: "",
            LastUpdatedBy: userData.profile.name,
            LastUpdatedTimeStampUTC: "",
            Location: otsHistory.Location,
            OTSDays: null,
            OTSHours: null,
            OutOfServiceDateTimeChanges: [],
            OutOfServiceDateTimeUTC: otsHistory.OutOfServiceTime,
            ProblemText: otsHistory.ProblemText,
            ProblemTextChanges: [],
            ReturnToServiceTimeChanges: [],
            ReturnToServiceTimeUTC: otsHistory.ReturnToService,
            SETD: "",
            Station: otsHistory.Station,
            EventType: otsHistory.EventType,
            EventTypeCategory: otsHistory.EventTypeCategory,
            id: otsHistory.Id,
            ConversationUniqueKey: otsHistory.ConversationUniqueKey,
            CreatedDateTimeUTC: new Date()
          }
          return otsAircraft;
        };

    function handleCardClick(otsEventHistory: any) {
        const historyAircraftEvent = mapAndDispatchAircraft(otsEventHistory);
        reload(true);
        dispatch(editAircraft(historyAircraftEvent)); 
      }
    return (
        <div className="event-history-info">
          {filteredOtsHistoryList.length>0 && <span className="header-form-fields">Recent Event History</span>}
            {filteredOtsHistoryList
                .sort((a: any, b: any) => getReturnTime(a.ReturnToService) - getReturnTime(b.ReturnToService))
                .map((event, index) => (
                    <div className='event-history-card' key={index} onClick={() => handleCardClick(event)} role="button"
                    tabIndex={0} onKeyDown={(e) => {if(e.key === 'Enter') {handleCardClick(event)}}}>
                        <div className='vertical-bundle'>
                            <div className='horizontal-bundle'>
                                <div className='ac-station-bundle'>
                                    <h1 className='ac-station'>{event.AircraftRegistration.substring(1)}</h1>
                                    <h1 className='ac-station'>{event.Station}</h1> 
                                </div>
                                <h1 className='return-time'>{getReturnTime(event.ReturnToService)} days ago</h1>
                            </div>
                            <h3 className='problem-text'><strong>Problem Summary:</strong> {event.ProblemText}</h3>
                        </div>
                    </div>
            ))}  
        </div>
    );
};
